module.exports = __webpack_public_path__ + "img/icon-question-rating-skin-smile.b186448d.svg";